import { useEffect, useState } from 'react'

/**
 * Full-page animated background. Sits behind all content (fixed, -z-10) so the
 * gradient flows continuously across every section. Blobs drift slowly on their
 * own and shift at different rates on scroll for a subtle parallax effect.
 */
const Background = () => {
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    let frame = 0
    const onScroll = () => {
      // throttle to one update per animation frame
      if (frame) return
      frame = requestAnimationFrame(() => {
        setScrollY(window.scrollY)
        frame = 0
      })
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', onScroll)
      if (frame) cancelAnimationFrame(frame)
    }
  }, [])

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-gradient-to-br from-cyan-50 via-primary-50 to-indigo-100">
      <div
        className="absolute -top-32 -right-24 will-change-transform"
        style={{ transform: `translateY(${scrollY * 0.18}px)` }}
      >
        <div className="w-[34rem] h-[34rem] bg-primary-300 rounded-full opacity-40 blur-3xl animate-blob" />
      </div>

      <div
        className="absolute top-1/4 -left-32 will-change-transform"
        style={{ transform: `translateY(${scrollY * -0.12}px)` }}
      >
        <div className="w-[30rem] h-[30rem] bg-cyan-300 rounded-full opacity-35 blur-3xl animate-blob animation-delay-2000" />
      </div>

      <div
        className="absolute top-1/2 left-1/3 will-change-transform"
        style={{ transform: `translateY(${scrollY * 0.1}px)` }}
      >
        <div className="w-[32rem] h-[32rem] bg-indigo-300 rounded-full opacity-35 blur-3xl animate-blob animation-delay-4000" />
      </div>

      <div
        className="absolute top-3/4 right-1/4 will-change-transform"
        style={{ transform: `translateY(${scrollY * -0.08}px)` }}
      >
        <div className="w-80 h-80 bg-sky-300 rounded-full opacity-30 blur-3xl animate-blob animation-delay-2000" />
      </div>
    </div>
  )
}

export default Background
